import { useCallback } from 'react'

import CreateFolderBase from './core/components/CreateFolderBase'
import { PlatformFSContext } from './core/context'
import * as fsOps from './core/fs-operations'
import type { IFile } from './core/types'

const platformContext = new PlatformFSContext()

interface IProps {
  dir: string
  files?: IFile[]
  domain: number
  onOk?: () => void
  disabled?: boolean
}

export default function CreateFolder({ dir, files, domain, onOk, disabled = false }: IProps) {
  const onCreate = useCallback(
    async (folderName: string) => {
      await fsOps.mkdir(platformContext, {
        path: `${dir}${folderName}/`,
        domain,
      })
    },
    [dir, domain],
  )

  return (
    <CreateFolderBase dir={dir} files={files} onCreate={onCreate} onOk={onOk} disabled={disabled} />
  )
}
